import PrioritizedWiki from "./PrioritizedWiki";

import "./PrioritizedWiki.scss";

export * from "./PrioritizedWiki.types";

export { PrioritizedWiki };
